<template>
  <modal
    name="create-company"
    transition="pop-out"
    :pivotY="0.2"
    height="auto"
    adaptive
    @before-open="beforeOpen"
  >
    <div class="p-3">
      <h2 class="py-1 text-lg font-semibold">Företag</h2>
      <BaseInput
        label="Företagsnamn"
        class="mt-2"
        v-model="form.name"
        placeholder="Klipp & Hår AB"
      />

      <BaseInput
        label="Företagsvisningsnamn / Salongsnamn (bookningsurl salong)"
        class="mt-2"
        v-model="form.displayname"
        placeholder="Klipp & Hår"
      />

      <BaseInput
        class="mt-2"
        label="Organisationsnummer utan bindestreck"
        placeholder="00000001234"
        v-model="form.vat"
      />

      <BaseInput
        label="Adress"
        class="mt-2"
        v-model="form.street"
        placeholder="Storgatan 10"
      />

      <div class="flex flex-row pb-4 mt-2 border-b">
        <BaseInput label="Stad" v-model="form.city" placeholder="Umeå" />
        <BaseInput
          label="Postnummer"
          v-model="form.zipcode"
          placeholder="900 00"
        />
      </div>

      <div class="p-2 bg-gray-100" v-for="(e, i) of form.employees" :key="i">
        <h2 class="py-1 text-lg font-semibold">Admin</h2>

        <div class="flex flex-row mt-2">
          <BaseInput label="Förnamn" v-model="e.firstname" placeholder="Anna" />
          <BaseInput
            label="Efternamn"
            v-model="e.lastname"
            placeholder="Andersson"
          />
        </div>
        <div class="mt-2">
          <BaseInput
            label="E-post"
            v-model="e.email"
            placeholder="anna@voady.se"
          />
        </div>
      </div>
      <div class="text-right">
        <button class="btn btn-default" @click="$modal.hide('create-company')">
          Avbryt
        </button>
        <button class="btn btn-primary" @click="handleSubmit">Spara</button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data() {
    return {
      parentCompanyId: '',
      form: {
        name: '',
        vat: '',
        displayname: '',

        city: '',
        zipcode: '',
        street: '',
        employees: [
          {
            ssc: '',
            firstname: '',
            lastname: '',
            email: '',
          },
        ],
      },
      submitLoading: false,
    }
  },
  methods: {
    beforeOpen({ params }) {
      if (params.parentCompanyId) {
        this.parentCompanyId = params.parentCompanyId
      }
    },
    async handleSubmit() {
      const employee = this.form.employees[0]
      try {
        this.submitLoading = true
        await this.$apollo.mutate({
          mutation: require('../../graphql/CreateCompany.gql'),
          variables: {
            data: {
              parentCompany: this.parentCompanyId || undefined,
              name: this.form.name,
              displayname: this.form.displayname,
              VAT: this.form.vat,
              saloon: {
                name: this.form.displayname,
                street: this.form.street,
                zipcode: this.form.zipcode,
                city: this.form.city,
                urlname: this.form.displayname
                  .toLowerCase()
                  .replace(/&/g, 'och')
                  .replace(/[èé]/g, 'e')
                  .replace(/\//g, '-')
                  .replace(/ö/g, 'o')
                  .replace(/[åä]/g, 'a')
                  .replace(/[^0-9a-z-]/g, ''),
              },
              employee: {
                ...employee,
                displayname: employee.firstname,
                companyAdmin: true,
              },
            },
          },
        })
        this.$modal.hide('create-company')
      } catch (error) {
        console.log(error)
      } finally {
        this.submitLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
